import { pages } from '../util/global-methods';

const routes = [
  {path: '404', name: '404', component: pages('error/404'), props: true, meta: {layout: 'default'}},
  {path: '500', name: '500', component: pages('error/500'), props: true, meta: {layout: 'default'}},
  {path: 'error/login', component: pages('error/login'), props: true, meta: {layout: 'default'}},
];

if(typeof window !== 'undefined'){
  routes.push({path: '*', name:'404', component: pages('error/404'), props: true, meta: {layout: 'default'}});
}
export default routes;
